<template>
  <div>
    <main class="home_v2">
      <carousel></carousel>
      <games-left-component :playGame="playGame"></games-left-component>
      <section class="game-history">
        <div class="game-history__avatars">
          <img :src="getTranslations.project_history_avatar_left_img" alt="">
          <img :src="getTranslations.project_history_avatar_right_img" alt="">
        </div>
        <div v-if="gameHistoryData.length" class="game-history-list_v2">
          <h2>{{ getTranslations.home_default_content_games_history }}</h2>
          <div class="list_date" v-if="!!gameHistoryDataForToday.length">
            <h1>{{ getTranslations.home_default_today }}</h1>
            <history-data-user v-for="(playedGame, index) in gameHistoryDataForToday"
                               :playedGame="playedGame"
                               :key="index">
            </history-data-user>
          </div>
          <div class="list_date" v-if="!!gameHistoryDataForOtherDays.length">
            <h1>{{ getTranslations.home_default_other_days }}</h1>
            <history-data-user v-for="(playedGame, index) in gameHistoryDataForOtherDays"
                               :playedGame="playedGame"
                               :key="index">
            </history-data-user>
          </div>
        </div>
        <div v-else>
          <div class="game-history-list home_empty">
            <h2>{{ getTranslations.home_default_content_games_history }}</h2>
            <img src="static/images/empty_home.svg" alt="">
            <h2>{{ getTranslations.home_no_game_history }}</h2>
            <p class="list-item__info__when">{{ getTranslations.home_no_game_history_text1 }}<br>{{
              getTranslations.home_no_game_history_text2 }}</p>
          </div>
        </div>
      </section>
    </main>
    <div class="bonus_phase_outer" v-if="!!phaseBonusList.length">
      <div v-for="(phase, index) in phaseBonusList" :key="index">
        <bonus-phase :phase="phase" :index="index"></bonus-phase>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint no-console: "off" */
import { mapGetters, mapState } from 'vuex';
import Vue from 'vue';
import NumbersFormattingMixin from '@/common/mixins/numbersFormatting';
import Carousel from './Carousel';
import GamesLeftComponent from './GamesLeftComponent';
import HistoryDataUser from './users/HistoryDataUser';
import BonusPhase from './BonusPhase';

const moment = require('moment');

Vue.use(require('vue-moment'), {
  moment,
});

export default {
  name: 'default-content',
  props: ['playGame'],
  components: {
    BonusPhase,
    HistoryDataUser,
    GamesLeftComponent,
    Carousel,
  },
  mixins: [NumbersFormattingMixin],
  created() {
    moment.locale(this.getLocale.toLowerCase());
  },
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
      'getLocale',
    ]),
    ...mapState('profile', [
      'phaseBonusList',
      'gameHistoryDataForOtherDays',
      'gameHistoryDataForToday',
      'gameHistoryData',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/DefaultContent.vue